// navLinks.js
import React from 'react';
import { ThemeIcon } from '@mantine/core';
import {
  IconDashboard,
  IconUser,
  IconPlus,
  IconTrash,
  IconMapPin,
  IconCircle,
  IconBuilding,
  IconAdjustmentsAlt,
  IconUserCode,
  IconCategory,
  IconCalendar,
  IconImageInPicture,
} from '@tabler/icons-react';

export const navLinks = [
  {
    label: 'Dashboard',
    to: '/dashboard',
    icon: (
      <ThemeIcon size="md">
        <IconDashboard style={{ width: '70%', height: '70%' }} />
      </ThemeIcon>
    ),
  },
  {
    label: 'Amenities',
    to: '/dashboard/amenities',
    icon: (
      <ThemeIcon size="md">
        <IconAdjustmentsAlt style={{ width: '70%', height: '70%' }} />
      </ThemeIcon>
    ),
  },
  {
    label: 'Developer',
    to: '/dashboard/developer',
    icon: (
      <ThemeIcon size="md">
        <IconUserCode style={{ width: '70%', height: '70%' }} />
      </ThemeIcon>
    ),
  },
  {
    label: 'Category',
    to: '/dashboard/category',
    icon: (
      <ThemeIcon size="md">
        <IconCategory style={{ width: '70%', height: '70%' }} />
      </ThemeIcon>
    ),
  },


  {
    label: 'State',
    to: '/dashboard/state',
    icon: (
      <ThemeIcon size="md">
        <IconMapPin style={{ width: '70%', height: '70%' }} />
      </ThemeIcon>
    ),
  },
  {
    label: 'City',
    to: '/dashboard/city',
    icon: (
      <ThemeIcon size="md">
        <IconCircle style={{ width: '70%', height: '70%' }} />
      </ThemeIcon>
    ),
  },
  {
    label: 'Enquiry',
    to: '/dashboard/enquiry',
    icon: (
      <ThemeIcon size="md">
        <IconCalendar style={{ width: '70%', height: '70%' }} />
      </ThemeIcon>
    ),
  },
  {
    label: 'Banner',
    to: '/dashboard/banner',
    icon: (
      <ThemeIcon size="md">
        <IconImageInPicture style={{ width: '70%', height: '70%' }} />
      </ThemeIcon>
    ),
  },
  {
    label: 'Property',
    icon: (
      <ThemeIcon size="md">
        <IconBuilding style={{ width: '70%', height: '70%' }} />
      </ThemeIcon>
    ),
    children: [
      {
        label: 'Property',
        to: '/dashboard/property',
        icon: (
          <ThemeIcon size="md">
            <IconPlus style={{ width: '70%', height: '70%' }} />
          </ThemeIcon>
        ),
      },
      // {
      //   label: 'Delete Property',
      //   to: '/dashboard/delete-property',
      //   icon: (
      //       <ThemeIcon size="md">
      //         <IconTrash style={{ width: '70%', height: '70%' }} />
      //       </ThemeIcon>
      //     ),
      // },
    ],
  },
  // {
  //   label: 'User',
  //   icon: (
  //     <ThemeIcon size="md">
  //       <IconUser style={{ width: '70%', height: '70%' }} />
  //     </ThemeIcon>
  //   ),
  //   children: [
  //     {
  //       label: 'Add User',
  //       to: '/dashboard/add-user',
  //       icon: (
  //         <ThemeIcon size="md">
  //           <IconPlus style={{ width: '70%', height: '70%' }} />
  //         </ThemeIcon>
  //       ),
  //     },
  //     {
  //       label: 'Delete User',
  //       to: '/dashboard/delete-user',
  //       icon: (
  //         <ThemeIcon size="md">
  //           <IconTrash style={{ width: '70%', height: '70%' }} />
  //         </ThemeIcon>
  //       ),
  //     },
  //   ],
  // },
];
